export default __webpack_public_path__ + "static/media/pieczatka4.f2fee50f.gif";